<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
body {
  margin: 0px;
}
.el-select {
  width: 100%;
}
.el-tabs__item {
  font-size: 16px !important;
  text-align: center;
}
.el-tabs--top .el-tabs__item.is-top {
  /* width: 90px !important; */
  text-align: center;
}
.el-tabs__item.is-active {
  color: #01c190 !important;
  font-weight: bold !important;
}

.el-tabs__active-bar {
  background-color: #01c190 !important;
  width: 0px !important;
}

.el-form-item__content {
  margin-left: 10px !important;
}

.el-input__inner {
  border: none !important;
  border-bottom: solid 1px #ddd !important;
  border-radius: 0px !important;
  padding-left: 0px !important;
  height: 30px !important;
  font-size: 14px !important;
}

.el-form-item__content {
  line-height: 30px !important;
}

.el-form-item__label {
  text-align: left !important;
  font-weight: 600 !important;
  color: #222222 !important;
  margin-bottom: 8px !important;
  line-height: 20px !important;
  padding-left: 10px;
}

.button {
  width: 70%;
  height: 42px;
  line-height: 42px;
  background: #01c190;
  border-radius: 4px;
  font-size:16px!important;
  color: #fff;
  text-align: center;
  margin: 0 auto;
  margin-top: 50px;
  border: solid 1px #01c190;
}

@media screen and (max-width: 500px) {
  .el-message {
    min-width: 300px !important;
  }
}

@media screen and (max-width: 500px) {
  .el-message-box {
    width: 300px !important;
  }
}

.el-textarea__inner {
  padding-left: 0px !important;
}
.el-select-dropdown__list{
  padding:10px 0px!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue